/**
 * Shared, calm disclaimers for all SEO tools. Keep wording identical site-wide
 * so legal review only needs to look in one place.
 */

export const TOOL_DISCLAIMER_GENERAL =
    "Buyer's Leverage provides decision-support information, not legal, engineering, inspection, contractor, lender, insurance, or financial advice. Repair exposure ranges are planning estimates, not bids.";

export const TOOL_DISCLAIMER_NEGOTIATION =
    "Actual negotiation outcomes depend on contract terms, market conditions, seller motivation, agent guidance, and professional follow-up.";

export const TOOL_DISCLAIMER_REPAIR_COSTS =
    "Local labor, materials, access, permits, and repair scope can significantly affect actual costs.";

export const TOOL_DISCLAIMER_RULE_BASED =
    "This free tool uses rule-based inputs and does not analyze your full inspection report. Upload your inspection report for a more specific report-based analysis.";

/**
 * Returns the disclaimer set for a tool, in the order they should render
 * inside the result card. Centralizing here prevents per-tool drift.
 */
export function disclaimersFor(toolName) {
    const base = [TOOL_DISCLAIMER_GENERAL];
    if (
        [
            "home-inspection-negotiation-calculator",
            "seller-credit-estimator",
            "inspection-contingency-timeline-planner",
            "should-i-buy-this-house-inspection-quiz",
        ].includes(toolName)
    ) {
        base.push(TOOL_DISCLAIMER_NEGOTIATION);
    }
    if (
        [
            "repair-exposure-calculator",
            "roof-repair-cost-calculator",
            "hvac-age-replacement-checker",
            "electrical-panel-concern-checker",
            "foundation-crack-severity-checker",
            "water-intrusion-risk-checker",
            "closing-cost-calculator",
        ].includes(toolName)
    ) {
        base.push(TOOL_DISCLAIMER_REPAIR_COSTS);
    }
    base.push(TOOL_DISCLAIMER_RULE_BASED);
    return base;
}
